import { Button, Field, FieldError, Textarea } from "@/components/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";

const resultSummarySchema = z.object({
  text: z.string().min(1, { message: "A lab comment is required." }),
});

type ResultSummaryFormValues = z.infer<typeof resultSummarySchema>;

interface ResultSummaryEditorProps {
  defaultValue?: string;
  onSave: (text: string) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export const ResultSummaryEditor = ({
  defaultValue,
  onSave,
  onCancel,
  isLoading,
}: ResultSummaryEditorProps) => {
  const form = useForm<ResultSummaryFormValues>({
    resolver: zodResolver(resultSummarySchema),
    mode: "onSubmit",
    defaultValues: {
      text: defaultValue ?? "",
    },
  });

  return (
    <div className="flex flex-col gap-3">
      <Controller
        control={form.control}
        name="text"
        render={({ field, fieldState }) => (
          <Field data-invalid={fieldState.invalid}>
            <Textarea
              autoFocus
              rows={6}
              aria-label="Lab comment"
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              aria-invalid={fieldState.invalid}
            />
            <FieldError errors={[fieldState.error]} />
          </Field>
        )}
      />
      <div className="flex gap-2 ml-auto">
        <Button size="xs" variant="secondary" type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          size="xs"
          type="button"
          isLoading={isLoading}
          onClick={form.handleSubmit((v) => onSave(v.text))}
        >
          Save
        </Button>
      </div>
    </div>
  );
};
